// extracted by mini-css-extract-plugin
module.exports = {"small_statistics_container":"SmallStatistics_small_statistics_container__2Ahox","button_switch":"SmallStatistics_button_switch__3tHmx","active":"SmallStatistics_active__33tzA"};